import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Main as Container } from 'Components/Main'
import { AssessmentWizard } from 'Components/assessments/AssessmentWizard'
import { useAuthTenant } from 'store/auth'
import { PageHeader } from 'Components/ui'

export const AssessmentWizardPage = () => {
  const { t } = useTranslation(['gap-analysis'])
  const navigate = useNavigate()
  const selectedTenant = useSelector(useAuthTenant)

  const handleDone = () => navigate('/vendor-assessments')

  return (
    <Container>
      <PageHeader
        title={t('gap-analysis:assessment.page.generateButton')}
        segments={[
          { label: t('common:breadcrumbs.thirdPartyRiskManagement') },
          { label: t('gap-analysis:assessment.page.title'), route: '/vendor-assessments' },
          { label: t('gap-analysis:assessment.wizard.breadcrumbLabel') },
        ]}
      />
      <AssessmentWizard
        onSuccess={handleDone}
        onCancel={handleDone}
        tenant={selectedTenant?.slug}
      />
    </Container>
  )
}
